module.exports = __webpack_public_path__ + "img/Ice_edge.853392e5.jpg";